import React from 'react'
import styles from './HeroSection.module.scss'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'
import CustomButton from '@common/components/CustomButton'

interface HeroProps {
  onJoin: () => void
}

const HeroSection: React.FC<HeroProps & WithI18nProps> = (props) => {
  const { i18n, onJoin } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <div className={styles.heroHeader}>{t('cooperationTitle', "携手美团、大众点评")}</div>
        <div className={styles.heroContentText}>{t('cooperationDescription', "掘金全球本地生活市场")}</div>
        <CustomButton variant='primary' className={styles.heroButton} onClick={onJoin}>{t('wantToJoin', "立即合作")}</CustomButton>
      </div>
    </section>
  )
}

const HeroSectionWithTranslator = withTranslator(HeroSection)
export default HeroSectionWithTranslator

